import React from 'react';
import { useLanguage } from '../i18n';

/**
 * Company credential: BSFZ Certified Innovation Competence (2023 to 2025),
 * with the two seals. About the company, not about the founder.
 */
const Certification: React.FC = () => {
  const { t } = useLanguage();

  return (
    <aside className="lp-certification" id="certification" aria-labelledby="certification-heading">
      <div className="lp-certification-inner">
        <div>
          <h3 id="certification-heading">{t.certification.title}</h3>
          <p className="lp-certification-text">{t.certification.description}</p>
        </div>
        <div className="lp-seals">
          <img src="/bsfz-seal-1.png" alt={t.certification.sealAlt2023} width={120} height={120} loading="lazy" />
          <img src="/bsfz-seal-2.png" alt={t.certification.sealAlt2025} width={120} height={120} loading="lazy" />
        </div>
      </div>
    </aside>
  );
};

export default Certification;
